import { Col, DatePicker, Input, Row } from "antd";
import React, { useState } from "react";

import { FaEdit } from "react-icons/fa";
import FormAction from "../../../../../../components/common/FormAction";

import "./BillPayCheck.css";

function BillPayCheck({ data }) {
  const [edit, setEdit] = useState(false);
  const onCancel = () => {
    setEdit(false);
  };
  return (
    <div className="bill-pay-check">
      {edit ? null : (
        <Row justify="end">
          <Col>
            <button className="edit-btn" onClick={() => setEdit(true)}>
              <FaEdit size={18} />
              <span>Edit</span>
            </button>
          </Col>
        </Row>
      )}
      <Row gutter={[0, 32]} className="check-container">
        <Col span={24}>
          <Row gutter={[0, 16]}>
            <Col span={24}>
              <Row justify="space-between">
                <Col>
                  <p>Integrity Oklahoma LLC </p>
                  <p>PO Box 1451</p>
                  <p>Bethany, OK 73008</p>
                </Col>
                <Col>
                  <p className="onclick-text">Rental Income Account </p>
                  <p>Liberty National Bank </p>
                  <p>13300 S Pennsylvania Ave</p>
                  <p>Oklahoma, OK 73170</p>
                </Col>
                <Col>
                  <p>
                    <strong>Date:</strong>
                  </p>
                  <p>
                    {!edit ? (
                      <strong>Check #:</strong>
                    ) : (
                      <strong>Payment Reference:</strong>
                    )}
                  </p>
                </Col>
                <Col>
                  {edit ? (
                    <>
                      <DatePicker
                        style={{ width: "200px", display: "block" }}
                      />
                      <Input
                        style={{ width: "200px", marginTop: "2px" }}
                        placeholder="Payment Reference here"
                      />
                    </>
                  ) : (
                    <>
                      <p>03/11/2023</p>
                      <p>007476</p>
                    </>
                  )}
                </Col>
              </Row>
            </Col>
            <Col span={24}>
              <p className="pay-order-of">
                Pay to the order of:<strong>{data}</strong>
              </p>
              <div className="amount-container">
                <p className="amount-text">
                  This amount:
                  <span>
                    THREE THOUSAND, EIGHT HUNDRED TWENTY-SIX AND 56/100 DOLLARS
                  </span>
                </p>
                <strong>$3,826.56</strong>
              </div>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row justify="space-between">
            <Col span={8}>
              {!edit ? (
                <p>Flooring 1012 nw 14th , Floorin</p>
              ) : (
                <Input placeholder="memo" />
              )}
              <p className="top-border">MEMO</p>
            </Col>
            <Col span={8}>
              <p className="top-border right-text">SIGNATURE</p>
            </Col>
          </Row>
        </Col>
      </Row>
      {edit ? <FormAction cancel={onCancel} /> : null}
    </div>
  );
}

export default BillPayCheck;
